import { useEffect, useState } from "react"
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import Tag from "../../../fragments/Tag";
import { caseQuickUpdate } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";
import InputBox from "../../../common/interactive/InputBox";
import { canBeDeleted, formatDate } from "../../../../lib/script";
import { deleteEntityPermission } from "../../../../lib/permissions";
import Backdrop from "../../../common/modal/Backdrop";
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";


const DeleteItem = ({data, type, folder, label, delete_spec, field}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled(type)

    const dispatch = useDispatch()  
    const [loading, setLoading] = useState(false)
    const [modalOpned, setModalOpened] = useState(false)

    const [isDisabled, setIsDisabled] = useState(false)
    const [disabledMessages, setDisabledMessages] = useState(null)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 


    const user = useSelector(state => state.user.user)   
    const openModalHandler = () => {
        if (!userPermissionDisabled) {
            setModalOpened(true)
        }
    }

    const closeModalHandler = () => {
        setModalOpened(false)
    }

    useEffect(() => {
        const folderData = activeCase?.[folder]
        if (!activeCase || !Array.isArray(folderData) || !data) {
            setIsDisabled(true)
            setDisabledMessages(null)
            return
        }

        const primaryField =
            folder === 'attorneys'
                ? 'is_managing_attorney'
                : field
                  ? field
                  : 'is_primary_insurance'

        const caseCompare = canBeDeleted(folderData, data, primaryField)

        setIsDisabled(!caseCompare.deletable)

        setDisabledMessages(
            !caseCompare.deletable
                ? [
                      `Please select a different Primary ${folder === 'attorneys' ? 'Atty' : 'Insurance'}`,
                  ]
                : null,
        )
    }, [activeCase, folder, field, data])


    const deleteHandler = async (event) => {
        if (!userPermissionDisabled) {
             event.preventDefault()
            setLoading(true)        
            try {
                const fd = new FormData(event.target)

                const formData = Object.fromEntries(fd.entries())

                let reqBody = {
                    type: type,
                    type_id:  data.id,
                    fields: {
                        active: false,
                        remove_reason: formData.drop_reason,
                        remove_date: formatDate(new Date())
                    }
                }

                // if (type == 'case_attorney') {
                //     // reqBody.fields.drop_reason = formData.drop_reason
                //     // reqBody.fields.drop_date = formatDate(new Date())
                // }

                const caseId = activeCase?.case?.id
                if (!caseId) {
                    return
                }

                const update = await caseQuickUpdate(userToken, caseId, reqBody, dispatch)

                if (update && update.errorMessage) {
                    dispatch(notificationActions.setError(update))
                } else {
                    let dispatchBody = {
                        folder: folder,
                        item: {
                            itemId: data.id,
                            fields: [
                                {
                                    field: 'active',
                                    value: 0
                                },
                                {
                                    field: 'remove_reason',
                                    value: formData.drop_reason
                                },
                                {
                                    field: 'remove_date',
                                    value: formatDate(new Date())
                                },
                            ]            
                        }
                    }
                    
                    dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
                }
                closeModalHandler()
            } finally {
                setLoading(false)
            }
        }
    }


    return <>
    {/* deleteEntityPermission(user?.permissions, delete_spec ? delete_spec : folder) &&  */}
        {deleteEntityPermission(user?.permissions, delete_spec ? delete_spec : folder) && <Button btnStyle={`btn_danger`} click={openModalHandler} title={'Delete item'} isDisabled={isDisabled} messages={disabledMessages} square={true}>
            <i className='ti ti-trash white'></i>
            <span className='sr-only'>delete item</span>
        </Button>}
        {modalOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={`Remove ${label}?`}>
                        <PannelBody background={"var(--line-transparent)"}>
                            <div className='flex-vertical-center'>
                                
                                {type == 'case_attorney' && <>
                                    {data.law_firm.name}
                                    <Tag type={'note'}>{data.law_firm.code}</Tag>
                                </> }
                                {type !== 'case_attorney' && <>
                                    {data.insurance_carrier.name}
                                    <Tag type={'note'}>{data.insurance_carrier.code}</Tag>
                                </> }
                            </div>                            
                        </PannelBody>
                        <PannelBody>
                            <form onSubmit={deleteHandler}>
                                <div className="row">
                                    <InputBox label={'Reason'} type={'text'} name={'drop_reason'}/>
                                </div>
                                <div className="row">
                                    <p className="font-14">
                                        Are you sure you want to remove this {label}?
                                    </p>     
                                    <div className='flex-container-equal m-top-24'>
                                        <Button btnStyle={'btn_danger'} type={'submit'} isLoading={loading}><i className="ti ti-trash"></i>Remove</Button>
                                        <Button click={openModalHandler} type={'button'}>Cancel</Button>
                                    </div>     
                                </div>     
                            </form> 
                                                 
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}

export default DeleteItem